import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';

const SOURCES = [
  {
    label: 'WENY News',
    href: 'https://www.weny.com/news/chemung-co-ida-approves-big-flats-residential-project-after-another-public-hearing/article_11dd42e9-9417-42fc-a1cf-9f3b5d60a268.html',
  },
  {
    label: 'WSKG',
    href: 'https://wskg.org/regional-news/2026-06-19/reporter-debrief-were-at-the-mercy-of-the-ida-say-officials-residents-over-30-year-tax-break-for-big-flats-housing-plan',
  },
];

const stats = [
  { num: '30-yr', label: 'Proposed tax break (PILOT)' },
  { num: '300', label: 'New apartments approved' },
  { num: '$57.6M', label: 'Project investment' },
  { num: '~4', label: 'Permanent jobs after build' },
];

function FeaturedIssue() {
  return (
    <section className="featured" id="big-flats-ida">
      <div className="container">
        <Reveal>
          <div className="section__eyebrow featured__eyebrow">Featured &middot; In the News</div>
          <h2 className="section__title featured__heading">The Fight for Big Flats</h2>
        </Reveal>

        <Reveal as="article" className="featured__card" variant="up">
          <div className="featured__body">
            <div className="featured__flag">
              <span className="featured__tag">Chemung County IDA</span>
              <span className="featured__meta">Big Flats Housing &middot; 2026</span>
            </div>

            <h3 className="featured__title">
              A 30-year tax break was approved for Big Flats. Neighbors deserve a real say.
            </h3>

            <p className="featured__lead">
              The Chemung County Industrial Development Agency approved a 300-apartment
              development in Big Flats with a 30-year payment-in-lieu-of-taxes (PILOT) deal.
              Town leaders and residents told reporters they felt &ldquo;at the mercy of the
              IDA&rdquo; &mdash; a $57.6&nbsp;million project promising only about four
              permanent jobs, with the local fire district left to serve 300 new homes.
            </p>

            <blockquote className="featured__quote">
              &ldquo;We&rsquo;re at the mercy of the IDA, and the projects that come in.&rdquo;
              <cite>&mdash; Big Flats Town Supervisor, reported by WSKG</cite>
            </blockquote>

            <p className="featured__pledge">
              <span className="featured__pledge-tag">Ron&rsquo;s Pledge</span>
              Ron Johanson will do everything he can to bring <strong>rights back to Big
              Flats</strong> &mdash; a real seat at the table on IDA decisions, tax breaks
              tied to actual jobs, public hearings at hours working families can attend, and
              protection for the taxpayers and volunteers left holding the bill.
            </p>

            <div className="featured__actions">
              <Link to="/priorities" className="btn btn--primary">Where Ron Stands</Link>
              <Link to="/contact" className="btn btn--ghost">Add Your Voice</Link>
            </div>

            <div className="featured__sources">
              <span>Read the reporting:</span>
              {SOURCES.map(s => (
                <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer">
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          <aside className="featured__stats" aria-label="Project by the numbers">
            {stats.map(s => (
              <div className="featured-stat" key={s.label}>
                <div className="featured-stat__num">{s.num}</div>
                <div className="featured-stat__label">{s.label}</div>
              </div>
            ))}
          </aside>
        </Reveal>
      </div>
    </section>
  );
}

export default FeaturedIssue;
